import React from "react";

const DataExchangeWidget: React.FC = () => {
  return (
    <div className="widget">
      <h2 className="text-lg font-bold mb-2">Data Exchange</h2>
      <img
        src="/images/DataExchangeWidget.png"
        alt="Data Exchange Chart"
        className="w-full h-auto"
      />
    </div>
  );
};

export default DataExchangeWidget;
